import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { Section, Reveal, Eyebrow, CTAButton, TrustBadges } from "./ui";
const comparison = [{
  before: "Cada mañana termina siendo una batalla.",
  after: "Empezás el día con una rutina más previsible."
}, {
  before: "Las crisis aparecen sin entender qué las provocó.",
  after: "Podés anticiparte a muchas situaciones difíciles."
}, {
  before: "Recibís consejos distintos y terminás más confundida.",
  after: "Encontrás una estrategia clara para cada momento."
}, {
  before: "La culpa aparece cuando sentís que no llegás.",
  after: "Recuperás seguridad para decidir y acompañar."
}, {
  before: "La escuela pide respuestas y no sabés qué llevar.",
  after: "Tenés herramientas concretas para trabajar en equipo."
}, {
  before: "Buscás información suelta sin saber por dónde empezar.",
  after: "Abrís el tomo indicado y volvés a tener un plan."
}];
export function Transformation() {
  return <Section id="transformacion" className="bg-white" data-id="element-274" data-mp="1c7330h1zxweb">
      <Reveal className="text-center" data-id="element-275" data-mp="176x8mt4cdvsj">
        <Eyebrow data-id="element-276" data-mp="175vvmj3rmz86">La diferencia de tener un plan</Eyebrow>
        <h2 className="mx-auto max-w-3xl font-serif-display text-3xl font-semibold leading-tight text-[var(--ink)] sm:text-4xl" data-id="element-277" data-mp="135c1loehobq9">
          De apagar incendios…{" "}
          <span className="text-[var(--accent)]" data-id="element-278" data-mp="y7tsny0h1wi9">a acompañar con más calma.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-279" data-mp="1uw01yy8c9d2v">
          No se trata de hacerlo perfecto: se trata de tener recursos claros cuando los necesitás.
        </p>
      </Reveal>

      <Reveal delay={0.08} data-id="element-280" data-mp="1m1v43uusf1du">
        <div className="mx-auto mt-7 max-w-4xl overflow-hidden rounded-[1.5rem] border border-[#e6eef5] bg-white p-2 shadow-[0_22px_55px_-34px_rgba(31,51,69,0.52)] sm:mt-12 sm:rounded-[2rem] sm:p-3" data-id="element-281" data-mp="1h5muewzd00e2">
          <div className="grid grid-cols-2 gap-2 sm:gap-3" data-id="element-282" data-mp="29t8uhv9domw6">
            <div className="rounded-xl bg-[#fff5f4] px-3 py-3 text-center sm:rounded-2xl sm:px-6 sm:py-5" data-id="element-283" data-mp="29rphcdj0qrym">
              <span className="mx-auto flex h-7 w-7 items-center justify-center rounded-full bg-[#f5d9d6] text-[#b35e57] sm:h-9 sm:w-9" data-id="element-284" data-mp="2ssdgeh09bppu">
                <XIcon className="h-4 w-4" aria-hidden data-id="element-285" data-mp="2jyijtxd7b7lt" />
              </span>
              <h3 className="mt-1.5 text-[10px] font-extrabold uppercase tracking-[0.12em] text-[#a65953] sm:mt-2 sm:text-xs" data-id="element-286" data-mp="2nz2ij5dfaja2">
                Sin un plan
              </h3>
            </div>
            <div className="rounded-xl bg-[#ecf8f0] px-3 py-3 text-center sm:rounded-2xl sm:px-6 sm:py-5" data-id="element-287" data-mp="2eymgm0cbvk7b">
              <span className="mx-auto flex h-7 w-7 items-center justify-center rounded-full bg-[var(--accent-green)] text-white sm:h-9 sm:w-9" data-id="element-288" data-mp="20z4n57o37irm">
                <CheckIcon className="h-4 w-4" aria-hidden data-id="element-289" data-mp="250yjj3r920lz" />
              </span>
              <h3 className="mt-1.5 text-[10px] font-extrabold uppercase tracking-[0.1em] text-[var(--accent-green)] sm:mt-2 sm:text-xs" data-id="element-290" data-mp="3vdxhz4h5c5ii">
                Con la guía
              </h3>
            </div>
          </div>

          <div className="mt-2 space-y-2 sm:mt-3 sm:space-y-3" data-id="element-291" data-mp="1nrnkieaqsbfw">
            {comparison.map(item => <div key={item.before} className="grid grid-cols-2 gap-2 sm:gap-3" data-id="element-292" data-mp="1jrdgh76ifv3o">
                <div className="flex min-h-[88px] items-start gap-1.5 rounded-xl border border-[#f5e2e0] bg-[#fffafa] p-2.5 text-left sm:min-h-[74px] sm:gap-3 sm:rounded-2xl sm:p-4" data-id="element-293" data-mp="1xhp9d8ax5xvv">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 flex-none text-[#c77b75] sm:h-4 sm:w-4" aria-hidden data-id="element-294" data-mp="27e22o52jy9q3" />
                  <p className="text-[10px] font-medium leading-[1.35] text-[#765b59] sm:text-sm" data-id="element-295" data-mp="22f8nm87maant">{item.before}</p>
                </div>
                <div className="flex min-h-[88px] items-start gap-1.5 rounded-xl border border-[#d8eee0] bg-[#f8fdf9] p-2.5 text-left sm:min-h-[74px] sm:gap-3 sm:rounded-2xl sm:p-4" data-id="element-296" data-mp="2gdp2wnjjp9hk">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-none text-[var(--accent-green)] sm:h-4 sm:w-4" aria-hidden data-id="element-297" data-mp="m20nyldbd6x6" />
                  <p className="text-[10px] font-bold leading-[1.35] text-[#3e6650] sm:text-sm" data-id="element-298" data-mp="h51rhw66gnvt">{item.after}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-2 grid grid-cols-2 gap-2 sm:mt-3 sm:gap-3" data-id="element-299" data-mp="nl0mrbclspic">
            <div className="rounded-xl bg-[#fff5f4] px-2 py-2 text-[9px] font-bold text-[#a65953] sm:rounded-2xl sm:py-3 sm:text-xs" data-id="element-300" data-mp="sjbw7kyzky01">
              Reaccionar por intuición
            </div>
            <div className="rounded-xl bg-[var(--ink)] px-2 py-2 text-[9px] font-bold text-white sm:rounded-2xl sm:py-3 sm:text-xs" data-id="element-301" data-mp="3vzsiuv414250">
              Elegir con una estrategia
            </div>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.15} className="mt-8 text-center sm:mt-12" data-id="element-302" data-mp="9pg32dp1w39v">
        <CTAButton data-id="element-303" data-mp="ej15chxofjev">Quiero empezar hoy</CTAButton>
        <TrustBadges className="mt-5" compact data-id="element-304" data-mp="3d89eajucwg0v" />
      </Reveal>
    </Section>;
}